The name of the hiring organization.
